// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"PortalCard_cardContainer__tQKTj"};